export default "__VITE_ASSET__NCvDlN2J__"